import { Route,Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProjectStrij } from './pages/ProjectsPage/ProjectPKStrij';
import {MainPage} from './pages/MainPagePage/MainpagePage';
import { Contacts } from './pages/ContactsPage/ConstactPage';
function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Layout/>} >
          <Route index element={<MainPage/>}/>
          <Route path='/projectStrij' element={<ProjectStrij/>}/>
          <Route path='/contacts' element={<Contacts/>}/>
        </Route>
      </Routes>
    </>
  );
}

export default App;
